function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.6,
  d: "M5.44921 5.59714L1.89614 8.963C1.56969 9.35499 1.00828 9.34388 0.694634 8.93923C0.428414 8.59577 0.436142 8.08556 0.712612 7.75221L4.03032 4.65625L0.712611 1.56029C0.436141 1.22694 0.428414 0.716734 0.694633 0.373268C1.00828 -0.0313845 1.56969 -0.0424901 1.89614 0.3495L5.44921 3.71536C5.44921 3.71536 5.75 4.10015 5.75 4.65625C5.75 5.21235 5.44921 5.59714 5.44921 5.59714Z",
  fill: "white"
});

const SvgBreadcrumbArrow = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgBreadcrumbArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/breadcrumb_arrow.90b221f8.svg";
export { ForwardRef as ReactComponent };